export default class Promotion {
  constructor(obj) {
    this.promotion_id = obj.promotion_id;
    this.name_for_customer = obj.name_for_customer;
    this.uses_whitelisted_patrons = obj.uses_whitelisted_patrons;
    this.patron_must_be_signed_in = obj.patron_must_be_signed_in;
    this.uses_promo_codes = obj.uses_promo_codes;
  }
}
